import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/business-partner/$id/_layout/address-and-contact/",
)({
  component: () => null,
});
